// frontend/src/hooks/useRuta.ts
// Ruta actual de la SPA (location.pathname) sin router: la app tiene una sola
// ruta aparte de "/" (el panel /admin). Escucha atrás/adelante del navegador.

import { useCallback, useEffect, useState } from 'react';

export function useRuta() {
  const [ruta, setRuta] = useState(() => window.location.pathname);

  useEffect(() => {
    const alNavegar = () => setRuta(window.location.pathname);
    window.addEventListener('popstate', alNavegar);
    return () => window.removeEventListener('popstate', alNavegar);
  }, []);

  // replace: sin dejar entrada en el historial (redirecciones).
  // estado: se guarda en history.state (p. ej. { desdeApp: true }).
  const navegar = useCallback((destino: string, { replace = false, estado = null as object | null } = {}) => {
    if (destino === window.location.pathname) return;
    if (replace) window.history.replaceState(estado, '', destino);
    else window.history.pushState(estado, '', destino);
    setRuta(destino);
  }, []);

  return { ruta, navegar };
}
